import { useKeycloak } from '@react-keycloak/web';
import React from 'react';

import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import CssBaseline from '@material-ui/core/CssBaseline';
import Drawer from '@material-ui/core/Drawer';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

import Copyright from 'components/CopyRight';
import BpLogo from 'components/Icons/BpLogo';
import SideBarLinks from 'components/SideBarLinks';

import { useAuthStates } from 'features/Auth/Slices/selectors';

import ProfileDialog from './ProfileDialog';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
	},
	toolbar: {
		background: 'white',
		paddingRight: 24, // keep right padding when drawer closed
	},
	toolbarIcon: {
		display: 'flex',
		alignItems: 'center',
		padding: theme.spacing(2),
		borderBottom: '1px solid #EEECF91A',
		cursor: 'pointer',
		...theme.mixins.toolbar,
	},
	appBar: {
		transition: theme.transitions.create(['width', 'margin'], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
	},
	appBarShift: {
		background: 'white',
		paddingLeft: drawerWidth,
		transition: theme.transitions.create(['padding'], {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
	},
	title: {
		flexGrow: 1,
	},
	drawerPaper: {
		position: 'relative',
		whiteSpace: 'nowrap',
		width: drawerWidth,
		transition: theme.transitions.create('width', {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.enteringScreen,
		}),
		background: '#1D1D1B',
		boxShadow: ' 0px 6px 12px rgba(0, 0, 0, 0.06)',
		borderRadius: '0px 32px 32px 0',
	},
	drawerPaperClose: {
		overflowX: 'hidden',
		transition: theme.transitions.create('width', {
			easing: theme.transitions.easing.sharp,
			duration: theme.transitions.duration.leavingScreen,
		}),
		width: theme.spacing(7),
		[theme.breakpoints.up('sm')]: {
			width: theme.spacing(9),
		},
	},
	appBarSpacer: theme.mixins.toolbar,
	content: {
		flexGrow: 1,
		height: '100vh',
		overflow: 'auto',
	},
	container: {
		paddingTop: theme.spacing(4),
		paddingBottom: theme.spacing(4),
	},
	p20: {
		paddingLeft: '20px',
	},
	p91: {
		paddingLeft: '91px',
	},
	bpText: {
		color: 'white',
		marginLeft: theme.spacing(1),
		fontWeight: 'bolder',
		fontFamily: 'sans-serif',
	},
}));

const HeaderAndDrawer: React.FC = ({ children }) => {
	const classes = useStyles();
	const { title } = useAuthStates();

	const [open, setOpen] = React.useState(false);

	const handleDrawer = () => setOpen(!open);

	return (
		<div className={classes.root}>
			<CssBaseline />
			<AppBar position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
				<Toolbar className={clsx(classes.toolbar, open ? classes.p20 : classes.p91)}>
					<Typography component="h1" variant="h6" color="inherit" noWrap className={classes.title}>
						{title}
					</Typography>
					<ProfileDialog />
				</Toolbar>
			</AppBar>
			<Drawer
				variant="permanent"
				classes={{
					paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
				}}
				open={open}>
				<div className={classes.toolbarIcon}>
					<Grid
						aria-label="close drawer"
						data-testid="toggle-drawer"
						onClick={handleDrawer}
						container
						alignItems="center">
						<BpLogo />
						{open && (
							<Typography variant="h5" className={classes.bpText}>
								Bharat<span style={{ color: '#00afcb' }}>Pe</span>
							</Typography>
						)}
					</Grid>
				</div>
				<SideBarLinks />
			</Drawer>
			<main className={classes.content}>
				<div className={classes.appBarSpacer} />
				<Container maxWidth={false} className={classes.container}>
					{children}
					<Box pt={4}>
						<Copyright />
					</Box>
				</Container>
			</main>
		</div>
	);
};

const Default: React.FC = ({ children }) => {
	const { keycloak } = useKeycloak();
	if (keycloak.authenticated) return <HeaderAndDrawer>{children}</HeaderAndDrawer>;
	return (
		<Container maxWidth={false} disableGutters={true} component="main">
			<CssBaseline />
			{children}
		</Container>
	);
};
export default Default;
